module.exports = __webpack_public_path__ + "img/home-slide4-mobile-gr-2x.fc97de6d.png";